export default "__VITE_ASSET__CFcZmABt__"